<template>
  <div class="screen-container">
    <!-- 顶部标题 -->
    <div class="header">
      <div class="time">{{ currentTime }}</div>
      <div class="title">{{areaName}}汇农服农业社会化服务平台</div>
      <el-button type="text"  @click="skipToIndex" class="online-text">在线交易平台</el-button>
    </div>

    <div class="content">
      <!-- 左侧图表 -->
      <div class="left-panel">
        <div class="chart-box">
          <div class="chart-title">年度土地流转</div>
          <div ref="landFlowChart" class="chart"></div>
        </div>
        <div class="chart-box">
          <div class="chart-title">承租人类型</div>
          <div ref="contractorTypeChart" class="chart"></div>
        </div>
        <div class="chart-box">
          <div class="chart-title">社会化服务面积</div>
          <div ref="serviceAreaChart" class="chart"></div>
        </div>
        <div class="service-area-container">
          <div class="chart-title">农事服务商服务面积</div>
          <div class="service-list">
            <div class="service-item" v-for="(item, index) in businessStats" :key="index">
              <div class="service-info">
                <div class="rank">{{ index + 1 }}</div>
                <div class="service-name">{{ item.companyName }}</div>
                <div class="service-area">{{ Math.round(item.companyArea) }}亩</div>
              </div>
              <div class="progress-container">
                <div class="progress-bar" :style="{ width: calculateProgress(Math.round(item.companyArea)) + '%' }"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 中间地图 -->
      <div class="center-panel">
        <LeafletMap></LeafletMap>
<!--        <div ref="mapContainer" id="mapBox" class="map-container"></div>-->
        <div class="map-stats">
          <div class="stat-item">
            <div class="stat-title">流转总面积</div>
            <div class="stat-land-value">{{ totalAreaCirculation ? totalAreaCirculation : 0 }}亩</div>
            <div v-if="growthRate > 0" class="stat-growth">较去年同期+{{ growthRate }}%</div>
            <div v-else-if="growthRate < 0" class="stat-growth">较去年同期-{{ growthRate }}%</div>
          </div>
          <div class="stat-item">
            <div class="stat-title">社会化服务总面积</div>
            <div class="stat-land-value">{{totalAreaSocial ? totalAreaSocial : 0}}亩</div>
            <div v-if="socialGrowthRate > 0" class="stat-growth">较去年同期+{{ socialGrowthRate }}%</div>
            <div v-else-if="socialGrowthRate < 0" class="stat-growth">较去年同期-{{ socialGrowthRate }}%</div>
          </div>
          <div class="stat-item">
            <div class="stat-title">新型经营主体</div>
            <div class="stat-value">{{totalCompany ? totalCompany : 0}}家</div>
          </div>
          <div class="stat-item">
            <div class="stat-title">农事服务商</div>
            <div class="stat-value">{{totalAgriculturalCompany ? totalAgriculturalCompany : 0}}家</div>
          </div>
        </div>
        <div class="map-stats">
          <div class="stat-item">
            <div class="stat-title">在线农机</div>
            <div class="stat-value">{{totalMachineryCompany ? totalMachineryCompany : 0}}台</div>
          </div>
          <div class="stat-item">
            <div class="stat-title">农资服务商</div>
            <div class="stat-value">{{totalAgriculturalMachineryCompany ? totalAgriculturalMachineryCompany : 0}}家</div>
          </div>
          <div class="stat-item">
            <div class="stat-title">贷款金额</div>
            <div class="stat-money-value">{{totalLoanMoney ? totalLoanMoney : 0}}元</div>
          </div>
          <div class="stat-item">
            <div class="stat-title">在线账务管理</div>
            <div class="stat-money-value">{{totalAccount ? totalAccount : 0}}家</div>
          </div>
        </div>
      </div>

      <!-- 右侧面板 -->
      <div class="right-panel">
        <div class="service-images">
          <div class="chart-title">星级园区</div>
          <!-- <div class="image-grid">
            <div class="image-item" v-for="(img, index) in serviceImages" :key="index">
              <img :src="img.url" :alt="img.title">
            </div>
          </div> -->
        </div>
        <div class="service-stats">
          <div class="chart-title">免费代理记账服务</div>
          <div class="stats-chart" ref="serviceStatsChart"></div>
        </div>
        <div class="service-stats">
          <div class="chart-title">在线贷款信息</div>
          <div class="stats-chart" ref="loansChart"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import router from '@/router'
import * as echarts from 'echarts'
import { mapGetters } from "vuex";
import { BMPGL } from "@/util/bmpgl.js";
import {
  selectCompanyStatistics,
  onlineMachineryList,
  getBusinessList,
  selectStatisticsMiddle,
  selectStatisticsLeft,
  creditAndAccount,
  getHeatMapData
} from "@/api/screenStatistics.js"
import {getSupplyInfoOfMaterials, getSupplyInfoOfService} from "@/api/supplyDemand.js";
import machineryInfoWindow from './components/machineryInfoWindow.vue';
import agriculturalInfoWindow from './components/agriculturalInfoWindow.vue';
import businessInfoWindow from './components/businessInfoWindow.vue';
import companyInfoWindow from './components/companyInfoWindow.vue';
import machineryServiceInfoWindow from './components/machineryServiceInfoWindow.vue';
import LeafletMap from './components/LeafletMap.vue';
import { offsetLocation } from '../../js/utils/util';

export default {
  name: 'ScreenStatistics',
  computed: {
      ...mapGetters(["topSelectAreacode", 'topSelectAreaname','identityObj']),
    },
  data() {
    return {
      ak: window.global.bmKey,
      lon: window.global.view.center[0],
      lat: window.global.view.center[1],
      businessIcon: require('@/assets/经营主体.png'),
      companyIcon: require('@/assets/农服商.png'),
      agriculturalIcon: require('@/assets/农资商.png'),
      machineryIcon: require('@/assets/农机.png'),
      zoom: 11,
      currentTime: '',
      areaName: '',
      areaCode: '',
      serviceImages: [],
      timeInterval: null,
      //一次性查询数据的数量
      pageSize: 500,
      selectedMarkers: ['heat','business', 'company', 'agricultural', 'machinery'], // 默认选中的标记类型
      markerOptions: [
        { value: 'star', label: '星级园区' },
        { value: 'heat', label: '流转热力图' },
        { value: 'business', label: '新型经营主体' },
        { value: 'company', label: '农事服务商'},
        { value: 'agricultural', label: '农资经销商'},
        { value: 'machinery', label: '在线农机'}
      ],
      markers: {
        star: [],
        heat: null,
        business: [],
        company: [],
        agricultural: [],
        machinery: []
      },
      totalAreaCirculation: 0,//流转总面积
      growthRate:0, //较去年增长比例
      totalAreaSocial: 0, //社会化服务总面积
      socialGrowthRate: 0, //社会化服务面积较去年增长比例
      totalCompany: 0, //新型经营主体
      totalAgriculturalCompany: 0, //农事服务商
      totalMachineryCompany: 0, //在线农机
      totalAgriculturalMachineryCompany: 0,  //农资服务商
      totalLoanMoney: 0, //贷款金额
      totalAccount: 0, //在线账务管理
      tenantTypeMap: [],   // 承租人类型映射
      landFlowData: [], // 土地流转数据
      serviceAreaData: [], // 社会化服务面积数据
      businessStats: [], // 合作社服务面积数据
      accountData: [], // 免费代理记账服务数据
      loansData: [], // 在线贷款信息数据
      maskOverlay: null, // 遮罩层
      heatmapData: [], // 热力图数据
    }
  },
  methods: {
    initMap() {
      // 传入密钥获取地图回调。
      BMPGL(this.ak)
        .then((BMapGL) => {
          // 创建地图实例
          let map = new BMapGL.Map("mapBox");
          const centerPoint = this.identityObj.centerPoint;

          if (centerPoint) {
            const pointArr = centerPoint.split(",");
            let point = new BMapGL.Point(pointArr[0], pointArr[1]);
            map.centerAndZoom(point, this.zoom);
          } else {
            let point = new BMapGL.Point("107.733534", "31.359755");
            map.centerAndZoom(point, this.zoom);
          }

          map.setMapType(BMAP_SATELLITE_MAP);
          var styleJson = [{
              "featureType": "transit", // 例如，隐藏公交站
              "elementType": "labels",
              "stylers": {
                  "visibility": "off"
              }
            },
            // 隐藏商业区域标签
            {
              "featureType": "poi",
              "elementType": "labels",
              "stylers": {"visibility": "off"}
            },
            // 隐藏水系标签
            {
              "featureType": "water",
              "elementType": "labels",
              "stylers": {"visibility": "off"}
            },
            // 隐藏道路标签（路标）
            {
              "featureType": "road.label",
              "elementType": "labels",
              "stylers": {
                "visibility": "off"
              }
            },
            // 隐藏植被区域（树林）
            {
              "featureType": "vegetation",
              "elementType": "all",
              "stylers": {
                "visibility": "off"
              }
            }
          ];
          map.setMapStyleV2({styleJson: styleJson}); // 应用自定义样式
          //开启鼠标滚轮缩放
          map.enableScrollWheelZoom(true);
          // 添加缩放控件
          var zoomCtrl = new BMapGL.ZoomControl();
          map.addControl(zoomCtrl);
          map.setMaxZoom(17);
          // 保存数据
          this.BMapGL = BMapGL;
          this.map = map;

          //增加掩膜
          this.addMapMask();
          // 添加地图事件监听
          map.addEventListener('zoomend', () => {
            this.updateMaskPosition();
          });
          map.addEventListener('moveend', () => {
            this.updateMaskPosition();
          });

          // 添加自定义控件
          this.map.addControl(this.createControl(BMapGL));
          this.initMapMarkers(BMapGL);

        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 创建自定义控件
    createControl(BMapGL) {
      const Control = function(options) {
        this.defaultAnchor = options.anchor || BMAP_ANCHOR_BOTTOM_LEFT;
        this.defaultOffset = options.offset || new BMapGL.Size(20, 20);
      }

      Control.prototype = new BMapGL.Control();
      let that = this;
      Control.prototype.initialize = function(map) {
        const div = document.createElement('div');
        div.className = 'map-controls';
        div.style.cssText = `
          position: absolute;
          left: 20px;
          bottom: 20px;
          z-index: 999;
          padding: 12px 20px;
          display: flex;
          flex-direction: column;
          gap: 5px;
        `;

        // 创建多选框
        that.markerOptions.forEach(option => {
          const container = document.createElement('div');
          container.style.display = 'inline-block';
          container.style.marginRight = '15px';

          const checkbox = document.createElement('input');
          checkbox.type = 'checkbox';
          checkbox.id = option.value;
          checkbox.checked = that.selectedMarkers.includes(option.value);
          checkbox.style.marginRight = '8px';
          checkbox.addEventListener('change', () => that.updateMapMarkers());

          const label = document.createElement('label');
          label.htmlFor = option.value;
          label.textContent = option.label;
          label.style.color = 'blue'; // 直接设置蓝色
          label.style.fontSize = '15px';
          label.style.cursor = 'pointer';

          container.appendChild(checkbox);
          container.appendChild(label);
          div.appendChild(container);
        });

        map.getContainer().appendChild(div);
        return div;
      };

      return new Control({
        anchor: BMAP_ANCHOR_BOTTOM_LEFT,
        offset: new BMapGL.Size(20, 20)
      });
    },
    // 初始化标点
    initMapMarkers(BMapGL) {
      this.getOnlineMachineryList();
      this.getAgriculturalList();
      this.getBusinessList();
      this.getCompanyList();
      this.getMachineryServiceList();
      this.getHeatMapData();
    },

    /**
     * 获取土地流转热力图数据
     */
    async getHeatMapData() {
      const res = await getHeatMapData({
        areaCode: this.areaCode,
      });
      if (res.code === 0) {
        this.heatmapData = res.data;
        this.initHeatmap(this.BMapGL);
      }
    },

    // 初始化热力图
    initHeatmap(BMapGL) {
      // 创建MapVGL视图
      const view = new mapvgl.View({
        map: this.map
      });

      // 创建热力图图层
      const heatmapLayer = new mapvgl.HeatmapLayer({
        size: 4000,       // 热力点半径（单位：米）
        max: 10000,        // 最大阈值
        height: 0,
        unit: 'm',
        gradient: {      // 颜色渐变配置
          0.0: 'rgba(50, 50, 256, 0.6)',
          0.2: 'rgba(50, 250, 56, 0.4)',
          0.4: 'rgba(50, 250, 56, 0.5)',
          0.6: 'rgba(50, 250, 56, 0.65)',
          0.8: 'rgba(250, 50, 56, 0.5)',
          1.0: 'rgba(250, 50, 56, 0.65)'
        }
      });

      // 设置数据
      heatmapLayer.setData(this.heatmapData.map(item => ({
        geometry: {
          type: 'Point',
          coordinates: [item.lng, item.lat]
        },
        properties: {
          count: item.areaNum
        }
      })));

      // 添加到视图
      view.addLayer(heatmapLayer);

      // 保存实例
      this.markers.heat = {
        view: view,
        layer: heatmapLayer,
        show: () => view.show(),
        hide: () => view.hide()
      };
    },

    // 更新标点显示状态
    updateMapMarkers() {
      const checkboxes = document.querySelectorAll('.map-controls input[type="checkbox"]');
      this.selectedMarkers = Array.from(checkboxes)
        .filter(checkbox => checkbox.checked)
        .map(checkbox => checkbox.id);

      Object.keys(this.markers).forEach(type => {
        const shouldShow = this.selectedMarkers.includes(type);
        if (type === 'heat') {
          if (this.markers.heat) {
            shouldShow ? this.markers.heat.show() : this.markers.heat.hide();
          }
        } else {
          this.markers[type].forEach(marker => {
            shouldShow ? marker.show() : marker.hide();
          });
        }
        if (this.currentInfoWindow) {
          this.map.closeInfoWindow(this.currentInfoWindow);
        }
      });
    },

    //获取地图上对应的数据

    /**
     * @description: 获取在线农机列表
     */
    async getOnlineMachineryList() {
      try {
        const firstPage = await onlineMachineryList({
            pageNo: 1,
            pageSize: this.pageSize,
            areaCode: this.areaCode
          });

          if (firstPage.data?.records?.length) {
            this.addMachineryMarkers(firstPage.data.records);
          }

          const sumCount = firstPage.data.total;
          const totalPage = Math.ceil(sumCount / this.pageSize);
          // 使用setTimeout异步加载剩余页数据
          for (let i = 2; i <= totalPage; i++) {
            setTimeout(async () => {
              const pageData = await onlineMachineryList({
                pageNo: i,
                pageSize: this.pageSize,
                areaCode: this.areaCode
              });
              if (pageData.data?.records?.length) {
                this.addMachineryMarkers(pageData.data.records);
              }
            }, (i-1) * 500); // 每页间隔500ms加载
          }
      } catch (error) {
        console.error('数据获取失败:', error);
      }
    },

    /**
     * 添加在线农机标点
     * @param data
     */
    addMachineryMarkers(dataList) {
      if (!dataList || !this.BMapGL) return;
        const BMapGL = this.BMapGL;
        const markerIcon = new BMapGL.Icon(
          this.machineryIcon,
          new BMapGL.Size(25, 30)
        );
        markerIcon.setImageSize(new BMapGL.Size(25, 30));
        const coordMap = new Map();
        dataList.forEach((ele) => {
          console.log('在线农机数据',ele);

          //处理偏移量
          const key = `${ele.lng},${ele.lat}`;
          const count = coordMap.get(key) || 0;
          coordMap.set(key, count + 1);

          // 计算偏移后的点坐标
          let location = offsetLocation(count, ele.lng, ele.lat);

          let pt = new BMapGL.Point(location.lng, location.lat);
          let marker = new BMapGL.Marker(pt, { icon: markerIcon });
          marker.machineryData = ele;
          marker.addEventListener('click', e => {
              this.showMachineryInfo(e.target);
          });

          this.markers.machinery.push(marker);
          this.map.addOverlay(marker);
        });
    },

    showMachineryInfo(marker) {
        if (this.currentInfoWindow) {
          this.map.closeInfoWindow(this.currentInfoWindow);
        }
        const info = marker.machineryData;

        info.authId = info.id;

        const ComponentClass = Vue.extend(machineryInfoWindow);
        const instance = new ComponentClass({
          router,
          propsData: {
            info,
          },
        });
        const content = instance.$mount().$el;

        this.currentInfoWindow = new BMapGL.InfoWindow(content, {
          width: 100,
          height: 100,
          offset: new BMapGL.Size(0, -10)
        });
        this.map.openInfoWindow(this.currentInfoWindow, marker.getPosition());
    },

    /**
       * 获取农资商数据

       */
    async getAgriculturalList() {
      try {
        const firstPage = await getSupplyInfoOfMaterials({
          pnum: 1,
          psize: this.pageSize,
          areaCode: this.areaCode
        });

        if (firstPage.data?.length) {
          this.addAgriculturalMarkers(firstPage.data);
        }

        const sumCount = firstPage.dataNum;
        const totalPage = Math.ceil(sumCount / this.pageSize);

        // 使用setTimeout异步加载剩余页数据
        for (let i = 2; i <= totalPage; i++) {
          setTimeout(async () => {
            const pageData = await getSupplyInfoOfMaterials({
              pageNo: i,
              pageSize: this.pageSize,
              areaCode: this.areaCode
            });
            if (pageData.data?.length) {
              this.addAgriculturalMarkers(pageData.data);
            }
          }, (i-1) * 500); // 每页间隔500ms加载
        }
      } catch (error) {
        console.error('数据获取失败:', error);
      }
    },

      /**
     *
     * @param dataList 绘制农资商标点
     */
    addAgriculturalMarkers(dataList) {
      if (!dataList || !this.BMapGL) return;
      const BMapGL = this.BMapGL;
      const markerIcon = new BMapGL.Icon(
        this.agriculturalIcon,
        new BMapGL.Size(25, 40)
      );
      markerIcon.setImageSize(new BMapGL.Size(25, 30));
      const coordMap = new Map();
      dataList.forEach((ele) => {

        //处理偏移量
        const key = `${ele.longitude},${ele.latitude}`;
        const count = coordMap.get(key) || 0;
        coordMap.set(key, count + 1);

        // 计算偏移后的点坐标
        let location = offsetLocation(count, ele.longitude, ele.latitude);

        let pt = new BMapGL.Point(location.lng, location.lat);
        let marker = new BMapGL.Marker(pt, { icon: markerIcon });
        marker.AgriculturaData = ele;
        marker.addEventListener('click', e => {
            this.showAgriculturaInfo(e.target);
        });
        this.markers.agricultural.push(marker);
        this.map.addOverlay(marker);

      });
    },

    showAgriculturaInfo(marker) {
      if (this.currentInfoWindow) {
        this.map.closeInfoWindow(this.currentInfoWindow);
      }
      const info = marker.AgriculturaData;
      // console.log(info, '查看农资info')

      const ComponentClass = Vue.extend(agriculturalInfoWindow);
      const instance = new ComponentClass({
        router,
        propsData: {
          info,
        },
      });
      const content = instance.$mount().$el;

      this.currentInfoWindow = new BMapGL.InfoWindow(content, {
        width: 300,
        height: 120,
        offset: new BMapGL.Size(0, -10)
      });
      this.map.openInfoWindow(this.currentInfoWindow, marker.getPosition());
    },

    /**
     * 获取经营主体数据
     */
    async getBusinessList() {
      try {
        const firstPage = await getBusinessList({
          pageNo: 1,
          pageSize: this.pageSize,
          areaCode: this.areaCode
        });
        if (firstPage.data?.records?.length) {
          this.addBusinessMarkers(firstPage.data.records);
        }
        console.log('经营主体数据',firstPage.data);
        const sumCount = firstPage.data.total;
        const totalPage = Math.ceil(sumCount / this.pageSize);
        // 使用setTimeout异步加载剩余页数据
        for (let i = 2; i <= totalPage; i++) {
          setTimeout(async () => {
            const pageData = await getBusinessList({
              pageNo: i,
              pageSize: this.pageSize,
              areaCode: this.areaCode
            });
            if (pageData.data?.records?.length) {
              this.addBusinessMarkers(pageData.data.records);
            }
          }, (i-1) * 500); // 每页间隔500ms加载
        }
      } catch (error) {
        console.error('经营主体数据获取失败:', error);
      }
    },

    addBusinessMarkers(dataList) {
        if (!dataList || !this.BMapGL) return;
        const BMapGL = this.BMapGL;
        const markerIcon = new BMapGL.Icon(
          this.businessIcon,
          new BMapGL.Size(25, 30)
        );
        markerIcon.setImageSize(new BMapGL.Size(25, 30));
        const coordMap = new Map();
        dataList.forEach((ele) => {
          if (ele.centerPoint == null) return;

          const point = ele.centerPoint.split(",");

          //处理偏移量
          const key = `${point[0]},${point[1]}`;
          const count = coordMap.get(key) || 0;
          coordMap.set(key, count + 1);

          // 计算偏移后的点坐标
          let location = offsetLocation(count, point[0], point[1]);

          let pt = new BMapGL.Point(location.lng, location.lat);
          let marker = new BMapGL.Marker(pt, { icon: markerIcon });
          ele.companyName =   ele.companyName != null ? ele.companyName : "";
          ele.companyAddress =   ele.companyAddress != null ? ele.companyAddress : "";
          marker.businessData = ele;
          marker.addEventListener('click', e => {
              this.showBusinessInfo(e.target);
          });

          this.markers.business.push(marker);
          this.map.addOverlay(marker);
      })
    },

    showBusinessInfo(marker) {
        if (this.currentInfoWindow) {
          this.map.closeInfoWindow(this.currentInfoWindow);
        }
        const info = marker.businessData;

        let width = 350;
        let height = 150;
        //处理时间
        if (info.companyVo && info.companyVo.length > 0) {
          info.companyVo.forEach((item) => {
            item.dayNum = item.createTime ? item.createTime.substr(8, 2) : "";
            item.yearNum = item.createTime
              ? item.createTime.substr(0, 4)
              : "";
            item.monthNum = item.createTime
              ? item.createTime.substr(5, 2)
              : "";
          })
        } else {
          height = 150;

        }
        info.authId = info.id;

        const ComponentClass = Vue.extend(businessInfoWindow);
        const instance = new ComponentClass({
          router,
          propsData: {
            info,
          },
        });
        const content = instance.$mount().$el;

        this.currentInfoWindow = new BMapGL.InfoWindow(content, {
          width: width,
          height: height,
          offset: new BMapGL.Size(0, -10)
        });
        this.map.openInfoWindow(this.currentInfoWindow, marker.getPosition());
    },

    /**
     * 获取农事服务商数据
     */
    async getCompanyList() {
      try {
          const firstPage = await selectCompanyStatistics({
            pageNo: 1,
            pageSize: this.pageSize,
            areaCode: this.areaCode
          });

          if (firstPage.data?.records?.length) {
            this.addCompanyMarkers(firstPage.data.records);
          }

          const sumCount = firstPage.data.total;
          const totalPage = Math.ceil(sumCount / this.pageSize);
          // 使用setTimeout异步加载剩余页数据
          for (let i = 2; i <= totalPage; i++) {
            setTimeout(async () => {
              const pageData = await selectCompanyStatistics({
                pageNo: i,
                pageSize: this.pageSize,
                areaCode: this.areaCode
              });
              if (pageData.data?.records?.length) {
                this.addCompanyMarkers(pageData.data.records);
              }
            }, (i-1) * 500); // 每页间隔500ms加载
          }
        } catch (error) {
          console.error('农事服务商数据获取失败:', error);
        }
    },

    addCompanyMarkers(dataList) {
        if (!dataList || !this.BMapGL) return;
        const BMapGL = this.BMapGL;
        const markerIcon = new BMapGL.Icon(
          this.companyIcon,
          new BMapGL.Size(25, 30)
        );
        markerIcon.setImageSize(new BMapGL.Size(25, 30));
        const coordMap = new Map();
        dataList.forEach((ele) => {
          if (ele.centerPoint == null) return;

          const point = ele.centerPoint.split(",");

          //处理偏移量
          const key = `${point[0]},${point[1]}`;
          const count = coordMap.get(key) || 0;
          coordMap.set(key, count + 1);

          // 计算偏移后的点坐标
          let location = offsetLocation(count, point[0], point[1]);

          let pt = new BMapGL.Point(location.lng, location.lat);
          let marker = new BMapGL.Marker(pt, { icon: markerIcon });
          ele.companyName =   ele.companyName != null ? ele.companyName : "";
          ele.companyAddress =   ele.companyAddress != null ? ele.companyAddress : "";
          marker.companyData = ele;
          marker.addEventListener('click', e => {
              this.showCompanyInfo(e.target);
          });

          this.markers.company.push(marker);
          this.map.addOverlay(marker);

        });
    },

    showCompanyInfo(marker) {
      if (this.currentInfoWindow) {
        this.map.closeInfoWindow(this.currentInfoWindow);
      }
      const info = marker.companyData;
      console.log(info, '查看农服商info')

      let width = 400;
      let height = 150;
      //处理时间
      if (info.companyVo && info.companyVo.length > 0) {
        info.companyVo.forEach((item) => {
          item.dayNum = item.createTime ? item.createTime.substr(8, 2) : "";
          item.yearNum = item.createTime
            ? item.createTime.substr(0, 4)
            : "";
          item.monthNum = item.createTime
            ? item.createTime.substr(5, 2)
            : "";
        })
      } else {
        height = 150;
      }
      info.authId = info.id;

      const ComponentClass = Vue.extend(companyInfoWindow);
      const instance = new ComponentClass({
        router,
        propsData: {
          info,
        },
      });
      const content = instance.$mount().$el;

      this.currentInfoWindow = new BMapGL.InfoWindow(content, {
        width: width,
        height: height,
        offset: new BMapGL.Size(0, -10)
      });
      this.map.openInfoWindow(this.currentInfoWindow, marker.getPosition());
    },

    /**
     * 农机服务商列表
     */
    async getMachineryServiceList() {
      try {
          const firstPage = await getSupplyInfoOfService({
            pnum: 1,
            psize: this.pageSize,
            areaCode: this.areaCode
          });
          if (firstPage.data?.length) {
            this.addMachineryServiceMarkers(firstPage.data);
          }

          const sumCount = firstPage.dataNum;
          const totalPage = Math.ceil(sumCount / this.pageSize);
          // 使用setTimeout异步加载剩余页数据
          for (let i = 2; i <= totalPage; i++) {
            setTimeout(async () => {
              const pageData = await getSupplyInfoOfService({
                pnum: i,
                psize: this.pageSize,
                areaCode: this.areaCode
              })
              if (pageData.data?.length) {
                this.addMachineryServiceMarkers(pageData.data);
              }
            }, (i-1) * 500)
          }
      } catch (error) {
        console.error('农机服务数据获取失败:', error);
      }
    },

    addMachineryServiceMarkers(dataList) {
      if (!dataList || !this.BMapGL) return;
        const BMapGL = this.BMapGL;
        const markerIcon = new BMapGL.Icon(
          this.companyIcon,
          new BMapGL.Size(25, 30)
        );
        markerIcon.setImageSize(new BMapGL.Size(25, 30));
        const coordMap = new Map();
        dataList.forEach((ele) => {
          if (ele.centerPoint == null) return;

          const point = ele.centerPoint.split(",");

          //处理偏移量
          const key = `${point[0]},${point[1]}`;
          const count = coordMap.get(key) || 0;
          coordMap.set(key, count + 1);

          // 计算偏移后的点坐标
          let location = offsetLocation(count, point[0], point[1]);

          let pt = new BMapGL.Point(location.lng, location.lat);
          let marker = new BMapGL.Marker(pt, { icon: markerIcon });
          marker.machineryServiceData = ele;
          marker.addEventListener('click', e => {
              this.showMachineryServiceInfo(e.target);
          });

          this.markers.company.push(marker);
          this.map.addOverlay(marker);
        });
    },

    showMachineryServiceInfo(marker) {
      if (this.currentInfoWindow) {
        this.map.closeInfoWindow(this.currentInfoWindow);
      }
      const info = marker.machineryServiceData;
      console.log(info, '查看农机服务商info')

      let width = 270;
      let height = 150;
      info.authId = info.companyAuthId;

      const ComponentClass = Vue.extend(machineryServiceInfoWindow);
      const instance = new ComponentClass({
        router,
        propsData: {
          info,
        },
      });
      const content = instance.$mount().$el;

      this.currentInfoWindow = new BMapGL.InfoWindow(content, {
        width: width,
        height: height,
        offset: new BMapGL.Size(0, -10)
      });
      this.map.openInfoWindow(this.currentInfoWindow, marker.getPosition());
    },


    /**
     * 增加地图掩膜
     */
   // addMapMask() {
    //   // 尝试从本地缓存获取边界数据
    //   const cachedBoundary = localStorage.getItem(`boundary_${this.identityObj.areaFullName}`);
    //   if (cachedBoundary) {
    //     const rs = JSON.parse(cachedBoundary);
    //     this.drawTransparentOverlay(rs);
    //     return;
    //   }

    //   var bdary = new BMapGL.Boundary();
    //   let that = this;
    //   bdary.get(this.identityObj.areaFullName, function (rs) {
    //       if (!rs || !rs.boundaries || rs.boundaries.length === 0) {
    //         console.warn('获取行政区边界失败，3秒后重试...');
    //         setTimeout(() => that.addMapMask(), 3000);
    //         return;
    //       }

    //       // 将边界数据存入本地缓存
    //       localStorage.setItem(`boundary_${that.identityObj.areaFullName}`, JSON.stringify(rs));
    //       that.drawTransparentOverlay(rs);
    //   });
    // },



    // 新增方法：绘制透明遮罩层

    addMapMask() {
      // 尝试从本地缓存获取边界数据
      const cachedData = localStorage.getItem(`boundary_${this.identityObj.areaFullName}`);
      console.log(this.identityObj, 'cachedData')
      console.log(this.identityObj.areaFullName, 'cachedData')
      console.log(cachedData, 'cachedData')
      if (cachedData) {
        const { rs, expireTime } = JSON.parse(cachedData);
        // 检查缓存是否过期
        if (new Date().getTime() < expireTime) {
          this.drawTransparentOverlay(rs);
          return;
        } else {
          // 缓存过期，移除缓存
          localStorage.removeItem(`boundary_${this.identityObj.areaFullName}`);
        }
      }

      var bdary = new BMapGL.Boundary();
      let that = this;
      bdary.get(this.identityObj.areaFullName, function (rs) {``
          if (!rs || !rs.boundaries || rs.boundaries.length === 0) {
            console.warn('获取行政区边界失败，3秒后重试...');
            setTimeout(() => that.addMapMask(), 3000);
            return;
          }

          // 设定缓存过期时间，这里设置为 24 小时后过期
          const expireTime = new Date().getTime() + 48 * 60 * 60 * 1000;
          // 将边界数据和过期时间存入本地缓存
          localStorage.setItem(`boundary_${that.identityObj.areaFullName}`, JSON.stringify({ rs, expireTime }));
          that.drawTransparentOverlay(rs);
      });
    },
    drawTransparentOverlay(rs) {
      try {
        if (!rs || !rs.boundaries || rs.boundaries.length === 0) {
          console.error('无效的边界数据');
          return;
        }

        // 确保地图已初始化
        if (!this.map) {
          console.error('地图未初始化');
          return;
        }

        // 获取地图中心点作为备用
        const center = this.map.getCenter() || new BMapGL.Point(107.733534, 31.359755);

        // 获取地图边界，如果无效则使用默认边界
        let bounds = this.map.getBounds();
        if (!bounds || !bounds.getSouthWest() || !bounds.getNorthEast()) {
          bounds = new BMapGL.Bounds(
            new BMapGL.Point(center.lng - 0.1, center.lat - 0.1),
            new BMapGL.Point(center.lng + 0.1, center.lat + 0.1)
          );
        }

        // 确保边界点有效
        const sw = bounds.getSouthWest() || new BMapGL.Point(center.lng - 0.1, center.lat - 0.1);
        const ne = bounds.getNorthEast() || new BMapGL.Point(center.lng + 0.1, center.lat + 0.1);

        // 计算扩展边界
        const outer = [
          new BMapGL.Point(sw.lng - 0.5, sw.lat - 0.5),
          new BMapGL.Point(ne.lng + 0.5, sw.lat - 0.5),
          new BMapGL.Point(ne.lng + 0.5, ne.lat + 0.5),
          new BMapGL.Point(sw.lng - 0.5, ne.lat + 0.5)
        ];

        // 将边界数据转换为BMapGL点数组
        const boundaryPoints = [];
        rs.boundaries.forEach(boundary => {
          const points = boundary.split(';').map(pointStr => {
            const [lng, lat] = pointStr.split(',');
            return new BMapGL.Point(lng, lat);
          });
          boundaryPoints.push(points);
        });

        // 清除旧的遮罩层
        if (this.maskOverlay) {
          this.map.removeOverlay(this.maskOverlay);
        }

        // 创建新的遮罩层
        this.maskOverlay = new BMapGL.Polygon([outer, ...boundaryPoints], {
          fillColor: '#fff',
          fillOpacity: 0.1,
          strokeColor: '#04842A',
          strokeOpacity: 1,
          strokeWeight: 3,
        });

        this.map.addOverlay(this.maskOverlay);
        this.lastBoundaryData = rs; // 保存边界数据用于更新

      } catch (error) {
        console.error('绘制遮罩层失败:', error);
      }
    },

    // 更新遮罩位置
    updateMaskPosition() {
      if (!this.maskOverlay || !this.lastBoundaryData) return;

      // 先移除旧的遮罩层
      this.map.removeOverlay(this.maskOverlay);

      // 重新绘制遮罩层
      this.drawTransparentOverlay(this.lastBoundaryData);
    },

    updateTime() {
      const now = new Date()
      const weekdays = ['日', '一', '二', '三', '四', '五', '六']
      this.currentTime = `${now.getFullYear()}年${now.getMonth() + 1}月${now.getDate()}日 星期${weekdays[now.getDay()]} ${now.getHours()}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
    },
    calculateProgress(area) {
      // 动态计算businessStats数组中的最大值
      const maxArea = Math.max(...this.businessStats.map(item => Math.round(item.companyArea)));
      return (area / maxArea) * 100;
    },
    initCharts() {
      // 处理土地流转数据
      const landFlowSeries = [];
      const years = [];

      // 转换数据结构
      if (this.landFlowData && Object.keys(this.landFlowData).length > 0) {
        // 生成系列数据
        for (const [name, values] of Object.entries(this.landFlowData)) {
          if (name === 'years') {
            years.push(...values);
            continue;
          }

          landFlowSeries.push({
            name,
            type: 'bar',
            barGap: 0,
            data: values.map(v => v === 0 ? undefined : v),
            emphasis: {
              focus: 'series'
            },
            label: {
              show: true,
              position: 'insideBottom',
              fontSize: 11,
              rotate: 90,
              distance: 16,
              verticalAlign: 'middle',
              formatter: function(params) {
                return params.value ? parseFloat(params.value.toFixed(2)) + '亩' : '0';
              }
            }
          });
        }
      }
      // 初始化土地流转图表
      const landFlow = echarts.init(this.$refs.landFlowChart)
      landFlow.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          position: ['50%', '50%'],
          formatter: function(params) {
            return params.map(item =>
              `${item.marker} ${item.seriesName}: ${item.value ? parseFloat(item.value.toFixed(2)) : 0}亩`
            ).join('<br>');
          },
        },
        legend: {
          show: false,
          textStyle: {
            color: '#fff'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '1%',
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: years,
          axisLabel: {
            color: '#fff'
          }
        },
        yAxis: {
          type: 'log',
          axisLabel: {
            color: '#fff',
            formatter: function(value) {
                return parseFloat(value.toFixed(2)) + '亩';
            }
          },
          min: 1
        },
        series: landFlowSeries
      })

      // 初始化承租人类型图表
      const contractorType = echarts.init(this.$refs.contractorTypeChart)
      contractorType.setOption({
        tooltip: {
          trigger: 'item'
        },
        legend: {
          show: false,
          orient: 'vertical',
          right: 1,
          top: 'center',
          textStyle: {
            color: '#fff'
          }
        },
        series: [
          {
            name: '承租人类型',
            type: 'pie',
            radius: '80%',
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            data: this.tenantTypeMap
          }
        ]
      })

      //处理社会化服务面积数据
      const serviceAreaSeries = [];
      // 转换数据结构
      if (this.serviceAreaData && Object.keys(this.serviceAreaData).length > 0) {
        // 生成系列数据
        ['耕', '种', '管', '收'].forEach(type => {
          if (this.serviceAreaData[type]) {
            serviceAreaSeries.push({
              name: type,
              type: 'bar',
              stack: 'total',
              data: this.serviceAreaData[type]
            });
          }
        });
      }
      // 初始化服务面积图表
      const serviceArea = echarts.init(this.$refs.serviceAreaChart)
      serviceArea.setOption({
        tooltip: {
          trigger: 'axis',
          formatter: function(params) {
            return params.map(item => {
              return `${item.seriesName}: ${item.value}亩`
            }).join('<br/>');
          }
        },
        legend: {
          data: serviceAreaSeries.map(item => item.name),
          textStyle: {
            color: '#fff'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '1%',
          top: '16%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.serviceAreaData.years || [],
          axisLabel: {
            color: '#fff'
          }
        },
        yAxis: {
          type: 'log',
          axisLabel: {
            color: '#fff',
            formatter: function(value) {
              return value + '亩';
            }
          },
          min: 1
        },
        series: serviceAreaSeries
      })

      // 免费代理记账服务图表
      const serviceStats = echarts.init(this.$refs.serviceStatsChart)
      serviceStats.setOption({
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '1%',
          top: '16%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.accountData.years || []
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: this.accountData.counts || [],
            type: 'bar',
            label: {
              show: true,
              position: 'top',
            },
          }
        ]
      })

      //在线贷款信息
      const loansChart = echarts.init(this.$refs.loansChart)
      loansChart.setOption({
        legend: {
          show: false,
          textStyle: {
            color: '#fff'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '1%',
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.loansData.years || [],
          axisLabel: {
            color: '#fff'
          }
        },
        yAxis: {
          scale: true, //自适应
          minInterval: 0.1, //分割刻度
          type: 'value',
          axisLabel: {
            formatter: function(value) {
              return (value / 10000).toFixed(1) + '万';
            },
            color: '#fff'
          }
        },
        series: [
          {
            name: '贷款次数',
            type: 'bar',
            barGap: 0,
            emphasis: {
              focus: 'series'
            },
            label: {
              show: true,
              position: 'top',
              formatter: function(params) {
                return params.value + '笔';
              }
            },
            data: this.loansData.totalCounts || []
          },
          {
            name: '贷款金额',
            type: 'bar',
            barGap: 0,
            emphasis: {
              focus: 'series'
            },
            label: {
              show: true,
              position: 'top',
              formatter: function(params) {
                return (params.value / 10000).toFixed(1) + '万';
              }
            },
            data: this.loansData.totalMoney || []
          },
        ]
      })

      window.addEventListener('resize', () => {
        landFlow.resize()
        contractorType.resize()
        serviceArea.resize()
        serviceStats.resize()
        loansChart.resize()
      })
    },
    hideSystemElements() {
      // const header = document.querySelector(".header")
      // let noShow = document.querySelector(".noShow")
      // const footer = document.querySelector(".footer")

      // if(header) header.style.display = "none"
      // if(noShow) noShow.style.display = "none"
      // if(footer) footer.style.display = "none"
    },

    async getData() {
      this.selectStatisticsMiddle()
      this.selectStatisticsLeft()
      this.creditAndAccount()
    },

    /**
     * 获取大屏中间统计数据

     */
    async selectStatisticsMiddle() {
      try {
        const res = await selectStatisticsMiddle({
          areaCode: this.areaCode
        })
        if (res.code === 0) {
          this.totalAreaCirculation = res.data.totalAreaCirculation;
          this.growthRate = res.data.growthRate;
          this.totalAreaSocial = res.data.totalAreaSocial;
          this.socialGrowthRate = res.data.socialGrowthRate;
          this.totalCompany = res.data.totalCompany;
          this.totalAgriculturalCompany = res.data.totalAgriculturalCompany;
          this.totalMachineryCompany = res.data.totalMachineryCompany;
          this.totalAgriculturalMachineryCompany = res.data.totalAgriculturalMachineryCompany;
          this.totalLoanMoney = res.data.totalLoanMoney;
          this.totalAccount = res.data.totalAccount;
        }

      } catch (error) {
        console.error('获取中间统计数据失败:', error);
      }
    },

    /**
     * 获取大屏左侧统计数据
     */
    async selectStatisticsLeft() {
      try {
        const res = await selectStatisticsLeft({
          areaCode: this.areaCode
        })
        if (res.code === 0) {
          this.businessStats = res.data.list;
          this.tenantTypeMap = res.data.tenantTypeMap || [];
          this.landFlowData = res.data.annualLandAreaMap;
          this.serviceAreaData = res.data.socialServiceAreaMap;

          this.$nextTick(() => {
            this.initCharts()
          })
        }
      } catch (error) {
        console.error('获取左侧统计数据失败:', error);
      }
    },

    async creditAndAccount() {
      try {
        const res = await creditAndAccount({
          areaCode: this.areaCode
        })
        if (res.code === 0) {
          this.accountData = res.data.accountVo || [];
          this.loansData = res.data.creditVo || [];

          this.$nextTick(() => {
            this.initCharts()
          })
        }
      } catch (error) {
        console.error('获取信用和账期统计数据失败:', error);
      }
    },

    async skipToIndex() {
      // 展示头部和尾部
      const header = document.querySelector(".header");
      const noShow = document.querySelector(".noShow")
      const footer = document.querySelector(".footer");
      if (header) header.style.display = "";
      if(noShow) noShow.style.display = ""
      if (footer) footer.style.display = "";
      // 跳转到首页
      this.$router.push({
        path: '/index'
      })
    }

  },

  mounted() {
    this.hideSystemElements()
    this.areaName = this.identityObj.areaName;
    this.areaCode = this.identityObj.areaCode;
    // this.initMap()
    this.getData()
    this.updateTime()
    this.timeInterval = setInterval(this.updateTime, 1000)

  },
  beforeUnmount() {

    if (this.timeInterval) {
      clearInterval(this.timeInterval)
    }
    window.removeEventListener('resize', this.resizeCharts)

    // 展示头部和尾部
    const header = document.querySelector(".header");
    const noShow = document.querySelector(".noShow")
    const footer = document.querySelector(".footer");
    if (header) header.style.display = "";
    if(noShow) noShow.style.display = ""
    if (footer) footer.style.display = "";
  },
  components: {
    LeafletMap,

  }
}
</script>

<style scoped>
.screen-container {
  width: 100%;
  height: 100vh;
  /* background: #000d4a; */
  background: url('../../assets/dpbj.png') no-repeat center center;
  background-size: cover;
  color: #fff;
  padding: 20px;
  box-sizing: border-box;
}

.header {
  display: flex;
  justify-content: center; /* 改为居中 */
  align-items: center;
  height: 30px;
  padding: 0 20px;
  position: relative; /* 添加相对定位 */
  background: url('../../assets/dptb.png') no-repeat center center;
  background-size: cover;
}

.title {
  font-size: 32px;
  font-weight: bold;
  background: linear-gradient(to right, #c3d6d7, #0073ff);
  -webkit-background-clip: text;
  color: transparent;
  text-align: center; /* 添加文本居中 */
}

.time {
  font-size: 18px;
  color: #d7e2e2;
  position: absolute; /* 时间绝对定位 */
  left: 3%; /* 靠左 */
}

.online-text {
  width: 200px;
  font-size: 18px;
  color: #30f3f9;
  position: absolute;
  right: 5%;
  background: url('../../assets/online.png') no-repeat center center;
  background-size: cover;
}

.content {
  display: flex;
  height: calc(100% - 80px);
  margin-top: 20px;
}

.left-panel,
.right-panel {
  width: 20%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 100%;
}

.center-panel {
  width: 60%;
  padding: 0 15px;
}

.chart-box {
  border-radius: 10px;
  padding: 10px;
  height: 24%;
  position: relative;
  margin-top: 15px; /* 为标题留出空间 */
  background: url('../../assets/dptbbj.png') no-repeat center center;
  background-size: cover;
}

.chart-title {
  font-size: 14px;
  color: #d8e4e4;
  text-align: center; /* 添加文本居中 */
  position: absolute;
  top: -15px; /* 一半在外面 */
  left: 50%;
  transform: translateX(-50%);
  width: 80%;
  background-size: cover;
  padding: 8px 0;
  z-index: 2;
  background: url('../../assets/dpbt.png') no-repeat center center;
  background-size: cover;
}

.chart {
  height: calc(100% - 30px);
  /* height: 100%; */
  width: 100%;
  margin-top: 10px; /* 为标题留出空间 */
}

.map-container {
  width: 100%;
  height: 85%;
  background: rgba(6, 30, 93, 0.5);
  border-radius: 10px;
}

.map-stats {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.stat-item {
  background: url('../../assets/dptbbj.png') no-repeat center center;
  background-size: cover;
  border-radius: 10px;
  text-align: center;
  flex: 1;
  margin: 0 10px;
}

.stat-title {
  font-size: 13px;
  color: hsl(186, 18%, 89%);
}

.stat-value {
  font-size: 20px;
  margin: 10px 0;
  color: #6967db;
}

.stat-land-value {
  font-size: 20px;
  margin: 5px 0;
  color: #16d58c;
}

.stat-money-value {
  font-size: 20px;
  margin: 10px 0;
  color: orange;
}

.stat-growth {
  font-size: 12px;
  color: #0f0;
}

.business-stats {
  height: calc(100% - 30px);
  overflow-y: auto;
}

.stats-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  background: rgba(6, 30, 93, 0.3);
  padding: 10px;
  border-radius: 5px;
}

.stats-rank {
  width: 24px;
  height: 24px;
  background: #30f3f9;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}

.stats-info {
  flex: 1;
}

.stats-name {
  font-size: 14px;
  margin-bottom: 5px;
}

.stats-value {
  font-size: 12px;
  color: #30f3f9;
}

.service-images {
  background: url('../../assets/dptbbj.png') no-repeat center center;
  background-size: cover;
  border-radius: 10px;
  padding: 15px;
  height: 70%;
  position: relative;
  margin-top: 15px; /* 为标题留出空间 */
}

.image-title {
  font-size: 18px;
  color: #d8e4e4;
  margin-bottom: 15px;
  text-align: center; /* 添加文本居中 */
  background: url('../../assets/dpbt.png') no-repeat center center;
  background-size: cover;
}

/* .image-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  height: calc(100% - 40px);
}

.image-item {
  background: #061e5d;
  border-radius: 5px;
  overflow: hidden;
}

.image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
} */

.service-stats {
  background: url('../../assets/dptbbj.png') no-repeat center center;
  background-size: cover;
  border-radius: 10px;
  padding: 15px;
  height: 40%;
  position: relative;
  margin-top: 15px; /* 为标题留出空间 */
}

.stats-chart {
  height: 100%;
  margin-top: 10px;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: rgba(48, 243, 249, 0.5);
  border-radius: 3px;
}

.map-controls {
  position: absolute;
  left: 20px;
  bottom: 20px;
  z-index: 999;
  background: rgba(6, 30, 93, 0.8);
  padding: 12px 20px;
  border-radius: 4px;
  border: 1px solid #30f3f9;
}

.map-controls input[type="checkbox"] {
  margin-right: 8px;
}

.map-controls label {
  color: #30a8ff;
  font-size: 14px;
  margin-right: 15px;
  cursor: pointer;
}

.service-area-container {
  background: url('../../assets/dptbbj.png') no-repeat center center;
  background-size: cover;
  width: 95%;
  border-radius: 10px;
  padding: 10px;
  height: 24%;
  position: relative;
  margin: 0 auto;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  margin-top: 15px; /* 为标题留出空间 */
}

.service-list {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: calc(100% - 30px);
  margin-top: 10px; /* 为标题留出空间 */
}

.service-item {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  padding: 8px 0;
}

.service-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
}

.rank {
  width: 24px;
  text-align: center;
  color: #fff;
}

.service-name {
  flex: 1;
  margin: 0 10px;
  color: #fff;
  font-size: 14px;
}

.service-area {
  color: #30f3f9;
  font-size: 14px;
}

.progress-container {
  width: 100%;
  height: 6px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 3px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  background: linear-gradient(to right, #30f3f9, #35c03a);
  border-radius: 3px;
  transition: width 0.5s ease;
}
</style>
